export default __webpack_public_path__ + "static/media/logo.124a71a6.png";